var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1 mb-4 text-start self-start first:px-0 last:px-0",class:{
    'items-center md:flex-col md:mx-auto md:px-4': !_vm.isVerticalRender,
  }},[_c('div',{staticClass:"me-4 mb-0",class:[
      { 'w-8 h-8 md:w-16 md:h-16 md:me-0 md:mb-4': !_vm.isVerticalRender },
      { 'w-12': _vm.isVerticalRender },
    ]},[_c('icon',{attrs:{"icon":_vm.icon,"width":"full","height":"auto","image-dimension":[20, 20]}})],1),_vm._v(" "),(_vm.text)?_c('rich-text-renderer',{attrs:{"document":_vm.text,"class-names":_vm.textRendererClasses}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }